// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7ad4ec98","796":"9c78983d"}[chunkId] + ".chunk.js";
};